import { routes } from '@components';
import { useView } from '@hooks';
import { Typography } from 'antd';
import useBreadcrumbs from 'use-react-router-breadcrumbs';

const { Text } = Typography;

export const Breadcrumbs = () => {
  const { isMobile } = useView();
  const breadcrumbs = useBreadcrumbs(routes);

  return breadcrumbs.map(({ breadcrumb }, index) => (
    <Text
      key={index}
      style={{ fontSize: isMobile ? 16 : 24, fontWeight: '700', color: 'rgba(0, 0, 0, 0.85)', marginBottom: isMobile ? 0 : '4px' }}
    >
      {breadcrumb}&nbsp;
    </Text>
  ));
};
